// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectProvider_E8nH5t6uhn7i7axnQtWv{display:flex;align-items:baseline;gap:1em}.SelectProvider_E8nH5t6uhn7i7axnQtWv>:first-child{flex-grow:1}`, "",{"version":3,"sources":["webpack://./src/components/formElements/SelectProvider/SelectProvider.module.scss"],"names":[],"mappings":"AAAA,qCACE,YAAA,CACA,oBAAA,CACA,OAAA,CAEA,kDACE,WAAA","sourcesContent":[".SelectProvider {\n  display: flex;\n  align-items: baseline;\n  gap: 1em;\n\n  > :first-child {\n    flex-grow: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SelectProvider": `SelectProvider_E8nH5t6uhn7i7axnQtWv`
};
export default ___CSS_LOADER_EXPORT___;
